module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card update-company"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Update Company\n    ")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.datasources,
      "label": "Select datasource",
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.datasource),
      callback: function($$v) {
        _vm.datasource = $$v
      },
      expression: "datasource"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mr-4",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "clear-icon": "",
      "clearable": "",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.companies,
      "loading": _vm.tableLoading,
      "pagination": _vm.tablePagination,
      "total-items": _vm.totalData,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    on: {
      "update:pagination": function($event) {
        _vm.tablePagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v("\n          " + _vm._s(props.item.companylegalname) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(props.item.streetaddress) + "\n        ")]), _vm._v(" "), _c('td', [_c('v-menu', {
          attrs: {
            "bottom": "",
            "left": ""
          }
        }, [_c('v-btn', {
          staticClass: "darken-1",
          attrs: {
            "slot": "activator",
            "icon": "",
            "flat": "flat"
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-title', {
          attrs: {
            "dark": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.viewCompany(props.item)
            }
          }
        }, [_vm._v("View")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
          attrs: {
            "dark": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editCompany(props.item)
            }
          }
        }, [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
          attrs: {
            "dark": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteCompany(props.item)
            }
          }
        }, [_vm._v("Delete")])], 1)], 1)], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('company-modal', {
    attrs: {
      "refreshTable": _vm.refreshTable,
      "show": _vm.companyModalDialog,
      "id": _vm.companyId,
      "readonly": _vm.companyModalReadonly
    },
    on: {
      "closeModal": _vm.closeModal
    }
  }), _vm._v(" "), _c('delete-company-modal', {
    attrs: {
      "show": _vm.deleteCompanyModalDialog,
      "id": _vm.companyId,
      "deleteCompany": _vm.deleteCompanyAction
    },
    on: {
      "closeModal": _vm.closeModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4545dea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Company/UpdateCompany.vue
// module id = 1714
// module chunks = 7